import styled from 'styled-components';

export const Container = styled.div`
    overflow-y: scroll;
    padding: 20px 50px 50px 50px;
    height: 100%;
    background-color: ${props => props.theme.backgroundColor};
}
`;

export const FilterArea = styled.div`
    width: 100%;
    height: 30px;
}
`;

export const EmptyArea = styled.div`
    margin-top: 50vh; 
    transform: translateY(-200%); 
}
`;